export default __webpack_public_path__ + "static/media/backgroundHairdresser.b0c061dc.png";